import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ulid } from 'ulid';

const createModalHolder = (id: string) => {
    const div = document.createElement('div');
    div.classList.add(
        "fixed",
        "top-0",
        "left-0",
        "right-0",
        "bottom-0",
        "z-50",
        "w-full",
        "p-4",
        "overflow-x-hidden",
        "overflow-y-auto",
        "md;inset-0",
        "h-calc(100%-1rem(]",
        "max-h-full",
    );
    div.id=id;
    const background = createBackground();
    div.appendChild(background);
    return div;
};

const createBackground = () => {
    const div = document.createElement('div');
    div.classList.add(
        "absolute",
        "inset-0",
        "bg-black",
        "opacity-50",
    );
    return div;
};

const Modal = ({
    show,
    toggle,
    children,
    center,
}: {
    show?: boolean
    toggle?: () => void,
    children: React.ReactNode,
    center?: boolean
}) => {
    const [canShow, setCanShow] = useState(false);
    const [id] = useState(ulid());
    useEffect(() => {
        if(show && !document.getElementById(id)) {
            document.body.insertBefore(createModalHolder(id), document.getElementById('root') as HTMLElement);
            setCanShow(true);
        } else if (!show && document.getElementById(id)) {
            document.getElementById(id)?.classList.add('hiding');
            setTimeout(() => {
                document.body.removeChild(document.getElementById(id) as HTMLElement);
                setCanShow(false);
            }, 300);
        }
        if(show) {
            const onKeyDown = (e: KeyboardEvent) => {
                if(e.key === 'Escape') {
                    toggle?.();
                }
            };
            document.addEventListener('keydown', onKeyDown);
            return () => {
                document.removeEventListener('keydown', onKeyDown);
            };
        }
    }, [show]);

    useEffect(() => {
        return () => {
            if(document.getElementById(id)) {
                document.body.removeChild(document.getElementById(id) as HTMLElement);
            }
        };
    }, []);

    return canShow && document.getElementById(id) ? ReactDOM.createPortal(
        (
            <div className={
                'absolute inset-0 ml-auto mr-auto mt-auto mb-auto w-full max-w-2xl max-h-full'
                + ` ${center ? 'flex items-center' : ''}`
            }>
                <div className="relative light:bg-white rounded-lg shadow-sm bg-deep-blue">
                    <div className="flex flex-col items-stretch justify-start rounded-t border-gray-600">
                        {children}
                    </div>
                </div>
            </div>
        ),
        document.getElementById(id) as HTMLElement,
    ) : null;
};
export default Modal;
